import { useBranding } from "@/contexts/BrandingContext";

// LMS wordmark built from the configured LMS name; standalone digits (e.g. the
// "4" in "Training 4 Retrofit") get the tilted green pill.
export const T4RWordmark = ({ compact = false, dark = false, size = "md" }) => {
  const { lms_name } = useBranding();
  const name = lms_name || "Learning Portal";
  const words = name.split(/\s+/);
  const pill = size === "lg" ? "h-9 min-w-9 px-1.5 text-xl" : "h-7 min-w-7 px-1 text-base";
  const text = size === "lg" ? "text-xl" : "text-[15px]";
  if (compact) {
    const mark = words.find((w) => /^\d+$/.test(w)) || name[0];
    return <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-green-500 font-heading text-lg font-black text-[#0B2418] -rotate-6" data-testid="t4r-wordmark-compact">{mark}</span>;
  }
  return (
    <div className={`flex flex-wrap items-center gap-1.5 font-heading font-extrabold tracking-tight leading-none ${dark ? "text-white" : "text-slate-900"}`} data-testid="t4r-wordmark">
      {words.map((w, i) => /^\d+$/.test(w)
        ? <span key={i} className={`inline-flex items-center justify-center rounded-md bg-green-500 font-black text-[#0B2418] -rotate-6 ${pill}`}>{w}</span>
        : <span key={i} className={text}>{w}</span>)}
    </div>
  );
};
